import { $ as e, A as t, B as n, C as r, D as ee, E as te, F as ne, G as i, H as a, I as o, J as s, K as c, L as l, M as u, N as d, O as f, P as p, Q as m, R as h, S as g, T as _, U as v, V as y, W as b, X as x, Y as S, _ as C, a as w, b as T, c as E, d as D, f as O, g as k, h as A, i as j, j as M, k as N, l as P, m as F, n as I, o as L, p as R, q as z, r as B, s as V, t as H, u as U, v as W, w as G, x as K, y as re, z as q } from "./sdk.gen-s8MJGGfo.js";
import { a as J, c as Y, d as X, f as ie, i as ae, l as Z, n as oe, o as se, r as ce, s as le, t as ue, u as de } from "./purchaseOrderStatus-BrtcrLmN.js";
import { t as fe } from "./usePurchaseOrderService-ZgDrXYJE.js";
import { z as Q } from "zod";
//#region src/generated/schemas.gen.ts
var pe = {
	type: "string",
	enum: ["VASCO"],
	description: "The fulfilment platform."
}, me = {
	type: "string",
	enum: ["status"]
}, he = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "The sort direction."
}, ge = {
	type: "string",
	enum: [
		"CANCELED",
		"COMPLETED",
		"CONCEPT",
		"PARTIALLY_RECEIVED",
		"REGISTERED",
		"REGISTRATION_REQUESTED"
	],
	description: "The status of the purchase order."
}, _e = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["CANCELED"]
		},
		canceledAt: {
			type: "string",
			format: "date-time",
			description: "The cancellation date of the purchase order."
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"canceledAt",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"lines"
	]
}, ve = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["COMPLETED"]
		},
		completedAt: {
			type: "string",
			format: "date-time",
			description: "The completion date of the purchase order."
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		receipts: {
			type: "array",
			items: {
				type: "object",
				properties: {
					addedAt: {
						type: "string",
						format: "date-time",
						description: "The moment when the receipt was added to the purchase order."
					},
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a receipt."
					},
					quantity: {
						anyOf: [{
							type: "integer",
							exclusiveMaximum: 0,
							minimum: -9007199254740991
						}, {
							type: "integer",
							exclusiveMinimum: 0,
							maximum: 9007199254740991
						}],
						description: "The quantity of the received product."
					}
				},
				required: [
					"addedAt",
					"product",
					"quantity"
				],
				description: "A receipt of the purchase order."
			},
			minItems: 1,
			maxItems: 1e3,
			description: "The receipts of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"completedAt",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines",
		"receipts"
	]
}, ye = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["CONCEPT"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status"
	]
}, be = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["PARTIALLY_RECEIVED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		},
		receipts: {
			type: "array",
			items: {
				type: "object",
				properties: {
					addedAt: {
						type: "string",
						format: "date-time",
						description: "The moment when the receipt was added to the purchase order."
					},
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a receipt."
					},
					quantity: {
						anyOf: [{
							type: "integer",
							exclusiveMaximum: 0,
							minimum: -9007199254740991
						}, {
							type: "integer",
							exclusiveMinimum: 0,
							maximum: 9007199254740991
						}],
						description: "The quantity of the received product."
					}
				},
				required: [
					"addedAt",
					"product",
					"quantity"
				],
				description: "A receipt of the purchase order."
			},
			minItems: 1,
			maxItems: 1e3,
			description: "The receipts of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines",
		"receipts"
	]
}, xe = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["REGISTERED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		externalReference: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The external reference of the purchase order provided by the fulfilment platform."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"externalReference",
		"lines"
	]
}, Se = {
	type: "object",
	properties: {
		id: {
			type: "string",
			format: "uuid",
			description: "The ID of the purchase order."
		},
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The creation date of the purchase order."
		},
		fulfilmentPlatform: {
			type: "string",
			enum: ["VASCO"],
			description: "The fulfilment platform."
		},
		status: {
			type: "string",
			enum: ["REGISTRATION_REQUESTED"]
		},
		deliverySupplierDetails: {
			type: "object",
			properties: {
				supplier: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The name of the supplier."
				},
				reference: {
					type: "string",
					minLength: 1,
					maxLength: 256,
					description: "The reference of the supplier."
				}
			},
			required: ["supplier"],
			description: "The delivery supplier details of the purchase order."
		},
		deliveryType: {
			type: "object",
			properties: {
				type: {
					type: "string",
					enum: [
						"CONTAINER",
						"PACKAGE",
						"PALLET"
					],
					description: "The type of the expected delivery."
				},
				quantity: {
					type: "integer",
					minimum: 1,
					maximum: 100,
					description: "The quantity of the expected delivery type."
				}
			},
			required: ["type", "quantity"],
			description: "The delivery type of the purchase order."
		},
		expectedDelivery: {
			type: "object",
			properties: {
				on: {
					type: "string",
					format: "date",
					description: "The expected delivery date."
				},
				timeslot: {
					type: "object",
					properties: {
						from: {
							type: "string",
							description: "The start time of the expected delivery. Must be before `to`."
						},
						to: {
							type: "string",
							description: "The end time of the expected delivery. Must be after `from`."
						}
					},
					required: ["from", "to"],
					description: "The timeslot of the expected delivery."
				}
			},
			required: ["on", "timeslot"],
			description: "The expected delivery of the purchase order."
		},
		lines: {
			type: "array",
			items: {
				type: "object",
				properties: {
					product: {
						type: "object",
						properties: {
							id: {
								type: "string",
								format: "uuid",
								description: "The ID of the product."
							},
							name: {
								type: "string",
								minLength: 1,
								maxLength: 250,
								description: "The name of the product."
							},
							ean: {
								type: "string",
								description: "The EAN of the product, either 8 or 13 characters long."
							},
							sku: {
								type: "string",
								minLength: 1,
								maxLength: 200,
								description: "The SKU of the product."
							}
						},
						required: ["id", "name"],
						description: "The product of a line."
					},
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e4,
						description: "The quantity of the product."
					}
				},
				required: ["product", "quantity"],
				description: "A line of the purchase order."
			},
			minItems: 1,
			maxItems: 500,
			description: "The lines of the purchase order."
		}
	},
	required: [
		"id",
		"createdAt",
		"fulfilmentPlatform",
		"status",
		"deliverySupplierDetails",
		"deliveryType",
		"expectedDelivery",
		"lines"
	]
}, Ce = {
	oneOf: [
		{ $ref: "#/components/schemas/CanceledPurchaseOrder" },
		{ $ref: "#/components/schemas/CompletedPurchaseOrder" },
		{ $ref: "#/components/schemas/ConceptPurchaseOrder" },
		{ $ref: "#/components/schemas/PartiallyReceivedPurchaseOrder" },
		{ $ref: "#/components/schemas/RegisteredPurchaseOrder" },
		{ $ref: "#/components/schemas/RegistrationRequestedPurchaseOrder" }
	],
	discriminator: {
		propertyName: "status",
		mapping: {
			CANCELED: "#/components/schemas/CanceledPurchaseOrder",
			COMPLETED: "#/components/schemas/CompletedPurchaseOrder",
			CONCEPT: "#/components/schemas/ConceptPurchaseOrder",
			PARTIALLY_RECEIVED: "#/components/schemas/PartiallyReceivedPurchaseOrder",
			REGISTERED: "#/components/schemas/RegisteredPurchaseOrder",
			REGISTRATION_REQUESTED: "#/components/schemas/RegistrationRequestedPurchaseOrder"
		}
	}
}, we = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, Te = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, Ee = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:not-found"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [404],
			description: "The HTTP status code generated by the origin server."
		}
	}
}] }, $ = Q.object({
	id: Q.string(),
	createdAt: Q.string(),
	fulfilmentPlatform: Q.nativeEnum(Z),
	deliverySupplierDetails: Q.object({
		supplier: Q.string().min(1).max(256),
		reference: Q.string().min(1).max(256).optional()
	}),
	deliveryType: Q.object({
		type: Q.nativeEnum(Y),
		quantity: Q.number().min(1).max(100)
	}),
	expectedDelivery: Q.object({
		on: Q.string(),
		timeslot: Q.object({
			from: Q.string().optional(),
			to: Q.string().optional()
		})
	}),
	lines: Q.array(Q.object({
		quantity: Q.number().min(-1500).max(1500),
		product: Q.object({
			id: Q.string(),
			name: Q.string().min(1).max(250),
			ean: Q.union([Q.string().length(8), Q.string().length(13)]).optional(),
			sku: Q.string().min(1).max(200).optional()
		})
	}))
}), De = $.extend({
	status: Q.literal(X.COMPLETED),
	completedAt: Q.string().optional()
}), Oe = $.extend({ status: Q.literal(X.CANCELED) }), ke = $.extend({ status: Q.literal(X.CONCEPT) }), Ae = $.extend({ status: Q.literal(X.PARTIALLY_RECEIVED) }), je = $.extend({ status: Q.literal(X.REGISTERED) }), Me = $.extend({ status: Q.literal(X.REGISTRATION_REQUESTED) }), Ne = Q.discriminatedUnion("status", [
	De,
	Oe,
	ke,
	Ae,
	je,
	Me
]);
//#endregion
export { $ as BasePurchaseOrderSchema, _e as CanceledPurchaseOrderSchema, ve as CompletedPurchaseOrderSchema, ye as ConceptPurchaseOrderSchema, Ne as CustomPurchaseOrderSchema, Z as FulfilmentPlatform, pe as FulfilmentPlatformSchema, be as PartiallyReceivedPurchaseOrderSchema, Te as ProblemDetailsInvalidRequestSyntaxSchema, Ee as ProblemDetailsNotFoundSchema, we as ProblemDetailsSchema, de as PurchaseOrderAggregation, me as PurchaseOrderAggregationSchema, Ce as PurchaseOrderSchema, X as PurchaseOrderStatus, ge as PurchaseOrderStatusSchema, Y as PurchaseOrderType, xe as RegisteredPurchaseOrderSchema, Se as RegistrationRequestedPurchaseOrderSchema, ie as SortDirection, he as SortDirectionSchema, H as getPurchaseOrders, I as getPurchaseOrdersByPurchaseOrderIdPackingSlip, ue as isCanceledPurchaseOrder, oe as isCompletedPurchaseOrder, ce as isConceptPurchaseOrder, ae as isPartiallyReceivedPurchaseOrder, J as isRegisteredPurchaseOrder, se as isRegistrationRequestedPurchaseOrder, le as isUpdatablePurchaseOrder, B as postAddLines, j as postCancel, w as postCreate, L as postRegister, V as postRemove, E as postRemoveLines, P as postSetDeliverySupplierDetails, U as postSetDeliveryType, D as postSetExpectedDelivery, O as postUpdateLineQuantity, m as purchaseOrderApiAcceptanceUrl, e as purchaseOrderApiUrl, fe as usePurchaseOrderService, R as zCanceledPurchaseOrder, F as zCompletedPurchaseOrder, A as zConceptPurchaseOrder, k as zFulfilmentPlatform, C as zGetPurchaseOrdersByPurchaseOrderIdPackingSlipData, W as zGetPurchaseOrdersByPurchaseOrderIdPackingSlipResponse, re as zGetPurchaseOrdersData, T as zGetPurchaseOrdersResponse, K as zPartiallyReceivedPurchaseOrder, g as zPostAddLinesData, r as zPostAddLinesResponse, G as zPostCancelData, _ as zPostCancelResponse, te as zPostCreateData, ee as zPostCreateResponse, f as zPostRegisterData, N as zPostRegisterResponse, t as zPostRemoveData, M as zPostRemoveLinesData, u as zPostRemoveLinesResponse, d as zPostRemoveResponse, p as zPostSetDeliverySupplierDetailsData, ne as zPostSetDeliverySupplierDetailsResponse, o as zPostSetDeliveryTypeData, l as zPostSetDeliveryTypeResponse, h as zPostSetExpectedDeliveryData, q as zPostSetExpectedDeliveryResponse, n as zPostUpdateLineQuantityData, y as zPostUpdateLineQuantityResponse, a as zProblemDetails, v as zProblemDetailsInvalidRequestSyntax, b as zProblemDetailsNotFound, i as zPurchaseOrder, c as zPurchaseOrderAggregation, z as zPurchaseOrderStatus, s as zRegisteredPurchaseOrder, S as zRegistrationRequestedPurchaseOrder, x as zSortDirection };
